<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{testNum}}" [matBadgeHidden]="testNum === 0" matBadgeOverlap="false" class="tab_test_badge">Trial's Tests</span>
        </ng-template>
        <dpi-test-list (listSizeChanged)="setTestNum($event)"> </dpi-test-list>
    </mat-tab>
    <mat-tab label="Details">
        <dpi-trail-details> </dpi-trail-details>
    </mat-tab>
    <mat-tab label="Condition">
        <dpi-trail-condition> </dpi-trail-condition>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{personNum}}" [matBadgeHidden]="personNum === 0" matBadgeOverlap="false" class="tab_trail_badge">Personal</span>
        </ng-template>
        <dpi-trail-personal (listSizeChanged)="setPersonNum($event)"> </dpi-trail-personal>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{setupNum}}" [matBadgeHidden]="setupNum === 0" matBadgeOverlap="false" class="tab_trail_badge">Setup</span>
        </ng-template>
        <dpi-trail-setup (listSizeChanged)="setSetupNum($event)"> </dpi-trail-setup>
    </mat-tab>
    <mat-tab label="Equipments">
        <ng-template mat-tab-label>
            <span matBadge="{{machineryNum + switchboardNum + controlSysNum + dpSensorNum}}" 
            [matBadgeHidden]="machineryNum + switchboardNum + controlSysNum + dpSensorNum === 0" 
            matBadgeOverlap="false" class="tab_trail_badge">Equipments</span>
        </ng-template>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{machineryNum}}" [matBadgeHidden]="machineryNum === 0" matBadgeOverlap="false" class="tab_trail_badge">
                        Main Engine / Machinery
                    </span>
                </ng-template>
                <dpi-trail-machinery (listSizeChanged)="setMachineryNum($event)"> </dpi-trail-machinery>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{switchboardNum}}" [matBadgeHidden]="switchboardNum === 0" matBadgeOverlap="false" class="tab_trail_badge">Main Switchboard</span>
                </ng-template>
                <dpi-trail-main-switchboard (listSizeChanged)="setSwitchboardNum($event)"> </dpi-trail-main-switchboard>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{controlSysNum}}" [matBadgeHidden]="controlSysNum === 0" matBadgeOverlap="false" class="tab_trail_badge">Control System</span>
                </ng-template>
                <dpi-trail-control-system (listSizeChanged)="setControlSysNum($event)"> </dpi-trail-control-system>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{dpSensorNum}}" [matBadgeHidden]="dpSensorNum === 0" matBadgeOverlap="false" class="tab_trail_badge">DP Sensor</span>
                </ng-template>
                <dpi-trail-dp-sensor (listSizeChanged)="setDpSensorNum($event)"> </dpi-trail-dp-sensor>
            </mat-tab>
        </mat-tab-group>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{docCapabilityNum + docDpEventNum + docModificationNum + docFmeaNum}}" 
            [matBadgeHidden]="docCapabilityNum + docDpEventNum + docModificationNum + docFmeaNum === 0" 
            matBadgeOverlap="false" class="tab_trail_badge">Documents</span>
        </ng-template>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{docCapabilityNum}}" [matBadgeHidden]="docCapabilityNum === 0" matBadgeOverlap="false" class="tab_trail_badge">DP Capability</span>
                </ng-template>
                <dpi-trail-document-capability (listSizeChanged)="setDocCapabilityNum($event)"> </dpi-trail-document-capability>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{docDpEventNum}}" [matBadgeHidden]="docDpEventNum === 0" matBadgeOverlap="false" class="tab_trail_badge">DP Event</span>
                </ng-template>
                <dpi-trail-document-dp-event (listSizeChanged)="setDocDpEventNum($event)"> </dpi-trail-document-dp-event>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{docModificationNum}}" [matBadgeHidden]="docModificationNum === 0" matBadgeOverlap="false" class="tab_trail_badge">Modification</span>
                </ng-template>
                <dpi-trail-document-modification (listSizeChanged)="setDocModificationNum($event)"> </dpi-trail-document-modification>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{docFmeaNum}}" [matBadgeHidden]="docFmeaNum === 0" matBadgeOverlap="false" class="tab_trail_badge">FMEA</span>
                </ng-template>
                <dpi-trail-document-fmea (listSizeChanged)="setDocFmeaNum($event)"> </dpi-trail-document-fmea>
            </mat-tab>
        </mat-tab-group>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label matTooltip="All recommendations of the trail">
            <span matBadge="{{recommendationNum}}" [matBadgeHidden]="recommendationNum === 0" matBadgeOverlap="false" class="tab_recommendation_badge">All Rec.</span>
        </ng-template>
        <dpi-recommendation (listSizeChanged)="setRecommendationNum($event)"> </dpi-recommendation>
    </mat-tab>
</mat-tab-group>
